<template>
	<picture v-if="sources.length>0">
		<source
			v-for="(srcset, i) in srcsets"
			:srcset="srcset.path"
			:type="srcset.type"
			:key="srcset.path">
		<img :src="img" :alt="alt" :aria-label="alt">
<!--{{srcsets}}-->
<!--		{{img}}-->
<!--		:style="styles"-->
<!--		<img src="img/creakyOldJPEG.jpg" alt="Alt Text!">-->
<!--		:style="styles"-->

<!--			<source media="print" srcset="/img/app-print.png" type="image/png">-->
			<!--					<source srcset="/img/app-print.webp" type="image/webp" />-->

			<!--					<source type="image/svg+xml" srcset="pyramid.svg">-->
			<!--					<source type="image/webp" srcset="pyramid.webp">-->
			<!--					media pour changer d'image artistique (image recadrée sur smartphone) -->
<!--			<source media="min-width: 800px" srcset="/img/app-print.png">-->
<!--			<source media="max-width: 300px" srcset="/img/app-300.png" type="image/png">-->
<!--			<source media="max-width: 400px" srcset="/img/app-400.png" type="image/png" />-->
<!--			<source media="max-width: 600px" srcset="/img/app-600.png" type="image/png" />-->
<!--			<source media="max-width: 1000px" srcset="/img/app-1000.png" type="image/png" />-->
<!--			<source srcset="/img/app.png" type="image/png" />-->
<!--			<img src="/img/app.png" alt="CoproPrivée - Application" aria-label="CoproPrivée - Application">-->

			<!--					<img src="/img/app-default.png" alt="CoproPrivée - Application" aria-label="CoproPrivée - Application" />-->
			<!--					<img srcset="/img/app.png 1920w,/img/app-1000.png 1024w,/img/app-600.png 640w,/img/app-400.png 320w" />-->
			<!--					<img src="default.png" srcset="small.png 320w, medium.png 640w, large.png 1024w, xl.png 1920w" alt="Test" />-->
			<!--					sizes="(max-width:400px) 400px,(max-width:600px) 600px,(max-width:1000px) 1000px,1500px"-->

			<!--						sizes="100vw"-->
			<!--					/img/app.png 1500w,-->
			<!--					/img/app-1000.png 1000w,-->
			<!--					/img/app-600.png 600w,-->
			<!--					/img/app-400.png 400w,-->

			<!--						sizes="(max-width: 300px) 300px, (max-width: 400px) 400px, (max-width: 600px) 600px, (max-width: 1000px) 1000px, 1500px"-->

			<!--					<img sizes="(max-width: 600px) 100vw, (min-width: 601px) and (max-width: 992px) 50vw, 33.3vw"-->
			<!--							 data-srcset="image-960.jpg 960w, image-720.jpg 720w, image-480.jpg 480w"-->
			<!--							 src="image-thumb.jpg"-->
			<!--							 data-src="image-480.jpg" />-->

			<!--						sizes="100vw"-->
			<!--					-->
			<!--					<img src="elva-800w.jpg" alt="Chris debout tenant sa fille Elva dans ses bras">-->

			<!--					<img srcset="elva-fairy-320w.jpg 320w,-->
			<!--             elva-fairy-480w.jpg 480w,-->
			<!--             elva-fairy-800w.jpg 800w"-->
			<!--							 sizes="(max-width: 320px) 280px,-->
			<!--            (max-width: 480px) 440px,-->
			<!--            800px"-->
			<!--							 src="elva-fairy-800w.jpg" alt="Elva habillée en fée">-->

			<!--					<img src="pyramid.png" alt="Pyramide régulière constituée de quatre triangles équilatéraux">-->


	</picture>
</template>
<style scoped>
	img{
		display: block;
	}
</style>
<!--<source v-if="srcXs" media="(max-width: 500px)" :srcset="srcXs">-->
<!--<source v-if="srcLg" media="(min-width: 1000px)" :srcset="srcLg">-->
<script>
	export default{
		props: {
			sources:{default:()=>[]},
			// sources:{default:null},
			// img:{required:true},
			alt:{default:null},
			// auto:{default:true},
			// styles:{default:null}
		},
		computed:{
			srcsets(){
				return this.sources.map(function(s){

					let type = null;
					let ext = s.split(".").slice(-1)[0];
					switch(ext){
						case 'png': type = 'image/png'; break;
						case 'jpg': type = 'image/jpeg'; break;
						case 'webp': type = 'image/webp'; break;
					}

					return {
						ext:ext,
						path:s,
						type:type,
					}
				});
			},
			img(){
				return this.sources[ this.sources.length - 1];
			}
		}
	}
</script>
